import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { PostCheckoutFlow } from '../../model'
import { usePersonalization } from '../../utils/personalization'

interface PostCheckoutEventProperties {
  assetId: string
  assetCtaValue?: string
  captureType: PostCheckoutFlow
  assetName: string
  captureResult?: string
}

interface PostCheckoutTracking {
  trackAssetImpression: () => void
  trackAssetClick: (ctaValue: string) => void
  trackBackToStore: () => void
  trackMerchantCaptureResult: (result: string) => void
}

interface AmplitudeEventProps {
  assetName: string
  assetCtaValue?: string
  captureResult?: string
}

const getEventProperties = (assetId: string, captureType: PostCheckoutFlow) => {
  return (props: AmplitudeEventProps): PostCheckoutEventProperties => {
    return { assetId, assetCtaValue: props.assetCtaValue, captureType, assetName: props.assetName, captureResult: props.captureResult }
  }
}

export const useTracking = (): PostCheckoutTracking => {
  const {
    postCheckout: { asset, flow },
  } = usePersonalization()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const getTrackingProperties = getEventProperties(asset.id, flow)

  const trackAssetImpression = (): void => {
    logEvent('Viewed Post Checkout Content', getTrackingProperties({ assetName: asset.label }))
  }
  const trackAssetClick = (ctaValue: string): void => {
    logEvent('Clicked Post Checkout Content', getTrackingProperties({ assetName: asset.label, assetCtaValue: ctaValue }))
  }

  const trackBackToStore = (): void => {
    logEvent('Pressed Post Checkout Back to Store Link', getTrackingProperties({ assetName: asset.label }))
  }

  const trackMerchantCaptureResult = (result: string): void => {
    logEvent('Merchant Capture Result', getTrackingProperties({ assetName: asset.label, captureResult: result }))
  }

  return { trackAssetImpression, trackAssetClick, trackBackToStore, trackMerchantCaptureResult }
}
